import { ChatMessage } from '../../AiAssistant/aiAssistantModel'

export type PromptType = 'normal' | 'adversarial'

export type GoldenPrompt = {
  prompt_id: string
  user_id: string
  prompt_text: string
  prompt_type: PromptType
  session_ref: string | null
  ancestor_id: string | null
  datetime_added: string
  deleted_at: string | null
}

export type GoldenPromptCreate = {
  user_id: string
  prompt_text: string
  prompt_type: PromptType
  session_ref?: string | null
  ancestor_id?: string | null
}

export function getUserPromptText(message: ChatMessage): string {
  return message.parts
    .filter((part) => part.type === 'text')
    .map((part) => (part as { type: 'text'; content: string }).content)
    .join('')
}

export function findGoldenPromptForUserMessage(
  message: ChatMessage,
  sessionId: string,
  goldenPrompts: GoldenPrompt[],
): GoldenPrompt | undefined {
  const text = getUserPromptText(message)
  if (text === '') {
    return undefined
  }
  return goldenPrompts.find(
    (gp) => gp.deleted_at === null && gp.session_ref === sessionId && gp.prompt_text === text,
  )
}

export type MutationState<TVars> = {
  isLoading: boolean
  variables?: TVars
}

export function isGoldenPromptPending(
  message: ChatMessage,
  match: GoldenPrompt | undefined,
  createState: MutationState<GoldenPromptCreate>,
  deleteState: MutationState<string>,
): boolean {
  if (
    createState.isLoading &&
    createState.variables?.prompt_text === getUserPromptText(message)
  ) {
    return true
  }
  if (deleteState.isLoading && match && deleteState.variables === match.prompt_id) {
    return true
  }
  return false
}
